
// src/components/Auth/RegisterForm.js
import React, { useState } from 'react';
import { Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const RegisterForm = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        agreeTerms: false
    });
    const [errors, setErrors] = useState({});

    const { register, loading, error } = useAuthStore();
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email) {
            newErrors.email = 'Email je povinný';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Neplatný email';
        }

        if (!formData.password) {
            newErrors.password = 'Heslo je povinné';
        } else if (formData.password.length < 8) {
            newErrors.password = 'Heslo musí mít alespoň 8 znaků';
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Hesla se neshodují';
        }

        if (!formData.agreeTerms) {
            newErrors.agreeTerms = 'Musíte souhlasit s podmínkami';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await register({
                email: formData.email,
                password: formData.password,
                fullName: formData.fullName,
            });
            navigate('/login?registered=true');
        } catch (error) {
            // Chyby jsou již zpracovány v store
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger">{error}</Alert>}

                    <Form.Group className="mb-3">
                        <Form.Label>Jméno</Form.Label>
                        <Form.Control
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                        />
                    </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>E-mail *</Form.Label>
                <Form.Control
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="vas@email.cz"
                    isInvalid={!!errors.email}
                    required
                />
                <Form.Control.Feedback type="invalid">
                    {errors.email}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Heslo *</Form.Label>
                <Form.Control
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                    required
                />
                <Form.Control.Feedback type="invalid">
                    {errors.password}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Label>Potvrzení hesla *</Form.Label>
                <Form.Control
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.confirmPassword}
                    required
                />
                <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Check
                    type="checkbox"
                    id="agreeTerms"
                    name="agreeTerms"
                    checked={formData.agreeTerms}
                    onChange={handleChange}
                    isInvalid={!!errors.agreeTerms}
                    label={<span>Souhlasím s <Link to="/terms" target="_blank">podmínkami služby</Link> *</span>}
                />
                <Form.Control.Feedback type="invalid" className="d-block">
                    {errors.agreeTerms}
                </Form.Control.Feedback>
            </Form.Group>

            <div className="d-grid mb-4">
                <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Registruji...
                        </>
                    ) : 'Registrovat se'}
                </Button>
            </div>

            <div className="text-center">
                <span className="text-muted text-small">Již máte účet? </span>
                <Link to="/login">Přihlaste se</Link>
            </div>
        </Form>
    );
};

export default RegisterForm;